import './Install.css'

export function Install() {
  return (
    <section className="install">
      <div className="install__box">
        <div className="install__content">
          <p className="install__title">Install</p>
          <p className="install__command"><span className="install__prompt">$ </span>curl -fsSL https://harness.tonbo.dev/install.sh | sh</p>
        </div>
      </div>
    </section>
  )
}
